import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleObj } from '../../../classes/role-obj';

@Component({
  selector: 'lib-delete-role-warning',
  templateUrl: './delete-role-warning.component.html',
  styleUrls: ['./delete-role-warning.component.scss']
})
export class DeleteRoleWarningComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RoleObj
  ) { }

  ngOnInit() {
  }

}
